// extracted by mini-css-extract-plugin
module.exports = {"FooterLink":"style-module--FooterLink--1OeA8","link":"style-module--link--1pZHB","annotation":"style-module--annotation--2RsQn"};